import { render, staticRenderFns } from "./ShowGames.vue?vue&type=template&id=e0743172&scoped=true"
import script from "./ShowGames.vue?vue&type=script&lang=js"
export * from "./ShowGames.vue?vue&type=script&lang=js"
import style0 from "./ShowGames.vue?vue&type=style&index=0&id=e0743172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0743172",
  null
  
)

export default component.exports